import axios from 'axios';

const request = async(uri, { method = 'GET', data, params, headers } = {}) => {
  try {
    const response = await axios({
      method: method,
      url: uri,
      data: data,
      params: params,
      headers: headers
    });
    return response;
  } catch (e) {
    let msg = e.message;
    if(e.response) {
      e.error = e.response;
    }  else {
      e.error = {};
      e.error.data= {};
      e.error.data.message = msg;
    }
    return e;
  }
}

export default request;